module.exports = __webpack_public_path__ + "img/upmoodwatch1.f64ec95a.png";